import {Component, inject} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {FormGroupComponent} from '../../components/form-group/form-group.component';
import {ToastrService} from 'ngx-toastr';
import {AuthService} from '../../services/auth-service/auth.service';
import {FormErrorService} from '../../services/form-error-service/form-error.service';

@Component({
  selector: 'app-reset-password',
  imports: [
    FormGroupComponent,
    ReactiveFormsModule
  ],
  templateUrl: './reset-password.component.html'
})
export class ResetPasswordComponent {
  private authService = inject(AuthService);
  private formErrorService = inject(FormErrorService);
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);
  private toastr = inject(ToastrService);
  private readonly email: string;
  private readonly token: string;

  form = new FormGroup({
    password: new FormControl('', Validators.required),
    password_confirmation: new FormControl('', Validators.required),
  });

  constructor() {
    this.token = this.activatedRoute.snapshot.paramMap.get('token') ?? '';
    this.email = this.activatedRoute.snapshot.queryParamMap.get('email') ?? '';
  }

  onSubmit() {
    this.authService.resetPassword(this.token, this.email, this.form.value.password ?? '', this.form.value.password_confirmation ?? '')
      .subscribe({
        next: () => {
          this.clearXsrfCookie();
          this.router.navigate(['login']).then();
          this.toastr.success('Password successfully changed');
        },
        error: response => this.formErrorService.mapErrorToForm(this.form, response),
      });
  }

  private clearXsrfCookie() {
    document.cookie = 'XSRF-TOKEN=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  }
}
